import { Expose } from "class-transformer";

export class Airport {
  @Expose() city: string;
  @Expose() country: string;
  @Expose() countryCode: string;
  @Expose() iata: string;
  @Expose() name: string;
  @Expose() rank: number;
  @Expose() searchText: string;
  @Expose() latitude: number;
  @Expose() longitude: number;
  @Expose() cityTranslations: {
    [key: string]: string;
  };
  @Expose() ec261: boolean;
  @Expose() timeZone: string;

  get cityInfo() {
    return `${this.city} (${this.iata})`;
  }
}
